(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    function initFanoraGalleryVideos() {
    document.querySelectorAll(
      '.fanora-gallery-video-element'
    ).forEach((video) => {
      if (video.dataset.fanoraVisibilityReady) return;
      video.dataset.fanoraVisibilityReady = 'true';

      video.autoplay = false;
      video.muted = true;
      video.controls = false;
      video.pause();

      let visible = false;

      const update = () => {
        if (visible && !document.hidden) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      const observer = new IntersectionObserver((entries) => {
        visible =
          entries[0].isIntersecting &&
          entries[0].intersectionRatio >= 0.6;

        update();
      }, { threshold: [0, 0.6] });

      observer.observe(video);
      document.addEventListener('visibilitychange', update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initFanoraGalleryVideos
    );
  } else {
    initFanoraGalleryVideos();
  }

  document.addEventListener(
    'shopify:section:load',
    initFanoraGalleryVideos
  );
  } catch(e) { console.error(e); }
})();

})();
